import { useReducer } from 'react';
import { type } from './protesisTramitesActions';
import { protesisTramitesReducer } from './protesisTramitesReducer';
import { ProtesisTramitesContext } from './ProtesisTramitesContext';

const init = () => {
  return {
    anualList: [],
    mensualDate: null,
    mensualList: [],
    anualDate: null,
  };
};

export const ProtesisTramitesProvider = ({ children }) => {
  const [protesisTramitesState, dispatch] = useReducer(protesisTramitesReducer, {}, init);

  const setProtesisTramitesAnualList = (payload) => {
    dispatch({
      type: type.anualList,
      payload: payload.data,
      date: payload.date,
    });
  };

  const setProtesisTramitesMensualList = (payload) => {
    dispatch({
      type: type.mensualList,
      payload: payload.data,
      date: payload.date,
    });
  };

  return (
    <ProtesisTramitesContext.Provider
      value={{
        ...protesisTramitesState,
        setProtesisTramitesAnualList,
        setProtesisTramitesMensualList,
      }}
    >
      {children}
    </ProtesisTramitesContext.Provider>
  );
};
